import React, { Fragment } from 'react'

const Info = () => {
    return (
        <div className='infback'>
        <h1 className="text-center" style={{fontSize: '2.2rem', fontWeight: 800, marginBottom: 30}}><i className='fas fa-bullseye' style={{marginLeft: 10}}></i>  أهداف الموقع </h1>
        <div className="container">
        <div>
        <ul className='fsiz'>
        <li className='fsiz'>
        تسليط الضوء ع المشروع القومي حياة كريمة والذى يستهدف الريف المصري وتحسن أوجه الحياة فيه
        </li>

        <li className='fsiz'>
        تدريب الطلاب على استخدام تقنيات التصوير الرقمي
        </li>

        <li className='fsiz'>
        تدريب الطلاب على معالجة الصورة باستخدام الفوتوشوب واللايت رووم
        </li>

        <li className='fsiz'>
        تدريب الطلاب على إنتاج معرض الكتروني باستخدام برامج Adobe Illustrator & Photoshop و VS Code
        </li>

        <li className='fsiz'>
        فتح سوق عمل غير نمطي أمام طلاب قسم تكنولوجيا التعليم
        </li>

        <li className='fsiz'>
        اتباع الإجراءات الاحترازية واستخدام الشبكة لمعرض بديل للمعارض التقليدية حرصا ع سلامة المتلقي
        </li>        
        </ul>
        </div>
        <div align='left' className=''>

        <h3 className='box-w'>
          أ.د/ إيمان زكي الشريف
        
        </h3>
        </div>
</div>
    </div>)
}

export default Info
